import { Paper, Table, TableContainer, TableHead, TableCell, TableBody, TableRow, Typography } from "@mui/material";

export default function NewCustomers({data}){

    const find = category => {
        const item = data.find(i => i.category === category);
        return parseFloat(item?.users || 0).toLocaleString();
    }

    return <>

        <Typography variant='h3'>Nouveaux clients</Typography>

        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Dentaire</TableCell>
                        <TableCell>Kiné</TableCell>
                        <TableCell>Médecine</TableCell>
                        <TableCell>Pharma</TableCell>
                        <TableCell>Santé Mentale</TableCell>
                        <TableCell>Infirmier</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow>
                        <TableCell>Nouveaux clients</TableCell>
                        <TableCell>{find('dentaire')}</TableCell>
                        <TableCell>{find('kine')}</TableCell>
                        <TableCell>{find('medecine')}</TableCell>
                        <TableCell>{find('pharma')}</TableCell>
                        <TableCell>{find('sante-mentale')}</TableCell>
                        <TableCell>{find('infirmiere')}</TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </TableContainer>

    </>

}